import classnames from 'clsx';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useEnableLotTracking } from '../../../../../../feature-flags/hooks/use-enable-lot-tracking';
import { messages } from '../messages';
import style from '../style.module.less';

export const LocationsHeader = () => {
  const isLotTrackingEnabled = useEnableLotTracking();
  return (
    <div
      className={classnames({
        [style['locations-header-extended']]: isLotTrackingEnabled,
        [style['locations-header']]: !isLotTrackingEnabled,
      })}
    >
      <div>
        <FormattedMessage {...messages.warehouseHeader} />
      </div>
      <div>
        <FormattedMessage {...messages.locationHeader} />
      </div>
      {isLotTrackingEnabled && (
        <>
          <div>
            <FormattedMessage {...messages.lotIDHeader} />
          </div>
          <div>
            <FormattedMessage {...messages.expirationDateHeader} />
          </div>
        </>
      )}
      <div className={style.centered}>
        <FormattedMessage {...messages.onHandHeader} />
      </div>
      <div className={style.centered}>
        <FormattedMessage {...messages.allocatedHeader} />
      </div>
      <div className={style.centered}>
        <FormattedMessage {...messages.availableHeader} />
      </div>
      <div className={style.centered}>
        <FormattedMessage {...messages.actionsHeader} />
      </div>
    </div>
  );
};
